import Button from "components/buttons";
import DynamicFormInput from "components/form/form";
import Notes from "components/notes";
import TeamView from "components/team_view";
import { useAuth } from "contexts/AuthContext";
import { useToast } from "contexts/ToastContext";
import TwoColumnLayout from "layouts/TwoColumnLayout";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { createLegalResearchRequest, createLegalResearchTopics, deleteLegalResearchTopic, updateLegalResearchRequest, updateLegalResearchTopic } from "services/legalResearchService";
import { LoadingIcon } from "utils/constant";
import { LEGAL_RESEARCH_REQUEST_STATUS, LEGAL_RESEARCH_REQUEST_TYPES } from "utils/constantValues";
import { prosecutors } from "utils/data";
import ActionAvatars from "./fragments/actionAvatars";

export default function CreateInternalNewRequest() {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const [submitting, setSubmitting] = useState(false);
    const navigate = useNavigate();
    const contextData = useAuth();
    const location = useLocation();
    const [viewTeam, setViewTeam] = useState(false);
    const [validationError, setValidationError] = useState<string | null>(null);
    const [teamId, setTeamId] = useState(0);

    const [formState, setFormState] = useState(location.state.formState || {});

    const [dataCollector, setDataCollector] = useState("");
    const [dataCollectorTeam, setDataCollectorTeam] = useState<{ id: string; topic_title: string }[]>(
        (formState?.research_teams.find((team: any) => team.prosecutors.find((prosecutor: any) => prosecutor.prosecutor_user_id === contextData.user.user_id)).topics ?? []).map((member: any) => ({
            ...member,
            id: member.id,
            topic_title: member.topic_title,
        }))

    );
    useEffect(() => { console.log("collector Team", dataCollectorTeam) }, [dataCollectorTeam]);
    const handleRemoveCollector = (id: string) => {
        setDataCollectorTeam((prev) => prev.filter((member) => member.id !== id));
    };
    const handleDataCollectors = (value: string) => {
        setDataCollector(value);
    };
    const getInitials = (str: string) =>
        str.split(" ").map(s => s[0]).join("").toUpperCase();
    const handleAddCollector = () => {
        if (dataCollector.trim() !== "") {
            setDataCollectorTeam((prev) => [
                ...prev,
                { id: Date.now().toString(), topic_title: dataCollector.trim() }
            ]);
            setDataCollector("");
        }
    };

    const [isTeamModalOpen, setIsTeamModalOpen] = useState(false);
    const { id } = useParams<{ id: string }>();

    const fileInputRefRequestLetter = useRef<HTMLInputElement>(null);
    const fileInputRefDraftInstruction = useRef<HTMLInputElement>(null);

    const handleChange = (
        e:
            | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            | ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setFormState((prev: any) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (
        file: any,
        fieldName: keyof Pick<
            typeof formState,
            "letter_file"
        >
    ) => {
        setFormState((prev: any) => ({
            ...prev,
            [fieldName]: file,
        }));
    };

    const handleSubmit = async () => {
        setSubmitting(true);

        if (dataCollectorTeam.length === 0) {
            setValidationError(t("PleaseAddAtLeastOneTopic"));
            return;
        }
        const data = new FormData();
        for (const key in formState) {
            const value = formState[key as keyof typeof formState];
            console.log(value);
            if (value !== null && value !== undefined) {
                if (value instanceof File) {
                    data.append(key, value);
                } else {
                    data.append(key, String(value));
                }
            }
        }
        data.append("status", LEGAL_RESEARCH_REQUEST_STATUS.title_requested.value);
        data.append("urgency_level", "high");

        try {
            const response = await updateLegalResearchRequest(id || "", data, contextData.token);

            const currentIds = dataCollectorTeam.map((m) => m.id.toString());
            console.log("current Ids", currentIds);
            for (const topic of formState?.research_teams.find((team: any) => team.prosecutors.find((prosecutor: any) => prosecutor.prosecutor_user_id === contextData.user.user_id)).topics) {
                if (!currentIds.includes(topic.id)) {
                    console.log("delete this topic", topic);
                    await deleteLegalResearchTopic(contextData.token, topic.id);
                }
            }
            for (const member of dataCollectorTeam) {
                const prosecutorData = new FormData();
                prosecutorData.append("research_request", response.id.toString());
                prosecutorData.append("topic_title", member.topic_title);
                prosecutorData.append("research_team",
                    formState.research_teams.find((team: any) => team.prosecutors.find((prosecutor: any) => prosecutor.prosecutor_user_id === contextData.user.user_id && prosecutor.is_team_leader)).id);
                const currentTopic = formState.internal_rsearc_topics.find((topic: any) => topic.id === member.id.toString());
                if (currentTopic)
                    await updateLegalResearchTopic(contextData.token, currentTopic.id, prosecutorData);
                else
                    await createLegalResearchTopics(contextData.token, prosecutorData);
            }
            setFormState((prev: any) => ({ ...prev, ...response }));
            navigate(`/conduct-legal-research/${id}`);
            showToast(t("LegalResearchRequestSentSuccess"), "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToSendLegalResearchRequest"), "error");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div>
            <form>
                <TwoColumnLayout
                    left={
                        <div className="py-[22px] px-[24px] bg-white rounded-xl">
                            <div className="flex gap-2">
                                <p className="text-lg font-semibold mb-4">{t("ResearchRequestTask")}: </p>
                                <p>{formState.research_task}</p>
                            </div>
                            {formState?.research_teams &&
                                formState?.research_teams.length !== 0 &&
                                formState?.research_teams.map((team: any, index: number) => (
                                    team.prosecutors.some((prosecutor: any) => prosecutor.prosecutor_user_id === contextData.user.user_id && prosecutor.is_team_leader) &&
                                    <div className="mt-6 mb-6 flex bg-gray-50 rounded-lg border border-gray-200">
                                        <ActionAvatars
                                            title={formState.requested_by === "internal" ? team.team_name : t("TeamList")}
                                            users={formState.requested_by === "internal" ? team.prosecutors.filter((prosecutor: any) => prosecutor.team_type === "prosecutor_topic_team") : formState?.prosecutor_assignments}
                                            prosecutor={true}
                                        />
                                        {contextData?.user?.roles?.some((p: any) => p === "LegalResearchCoordinator") &&
                                            formState.requested_by !== "internal" &&
                                            <svg onClick={() => setIsTeamModalOpen(true)} className="my-auto mr-2 hover:bg-gray-300 rounded-lg cursor-pointer" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.66406 21V16.75L16.8641 3.575C17.0641 3.39167 17.2851 3.25 17.5271 3.15C17.7691 3.05 18.0231 3 18.2891 3C18.5551 3 18.8134 3.05 19.0641 3.15C19.3147 3.25 19.5314 3.4 19.7141 3.6L21.0891 5C21.2891 5.18333 21.4351 5.4 21.5271 5.65C21.6191 5.9 21.6647 6.15 21.6641 6.4C21.6641 6.66667 21.6184 6.921 21.5271 7.163C21.4357 7.405 21.2897 7.62567 21.0891 7.825L7.91406 21H3.66406ZM18.2641 7.8L19.6641 6.4L18.2641 5L16.8641 6.4L18.2641 7.8Z" fill="black" />
                                            </svg>}
                                        <svg onClick={() => { setTeamId(index); setViewTeam(!viewTeam) }} className="mr-2 ml-auto my-auto cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <mask id="mask0_9_31087" maskUnits="userSpaceOnUse" x="1" y="5" width="22" height="14">
                                                <path d="M12 18C17.523 18 22 12 22 12C22 12 17.523 6 12 6C6.477 6 2 12 2 12C2 12 6.477 18 12 18Z" fill="white" stroke="white" strokeWidth="1.33333" strokeLinejoin="round" />
                                                <path d="M12 14.5C12.663 14.5 13.2989 14.2366 13.7678 13.7678C14.2366 13.2989 14.5 12.663 14.5 12C14.5 11.337 14.2366 10.7011 13.7678 10.2322C13.2989 9.76339 12.663 9.5 12 9.5C11.337 9.5 10.7011 9.76339 10.2322 10.2322C9.76339 10.7011 9.5 11.337 9.5 12C9.5 12.663 9.76339 13.2989 10.2322 13.7678C10.7011 14.2366 11.337 14.5 12 14.5Z" fill="black" stroke="black" strokeWidth="1.33333" strokeLinejoin="round" />
                                            </mask>
                                            <g mask="url(#mask0_9_31087)">
                                                <path d="M0 0H24V24H0V0Z" fill="#EFC83D" />
                                            </g>
                                        </svg>
                                    </div>))
                            }
                            <DynamicFormInput
                                inputs={[
                                    {
                                        value: formState?.reason,
                                        type: "select",
                                        label: t("ReasonForLegalRequest"),
                                        name: "reason",
                                        options: LEGAL_RESEARCH_REQUEST_TYPES,
                                        rules: {
                                            required: "",
                                        },
                                        onChange: handleChange,
                                        placeholder: t("TypesHere"),
                                    },
                                ]}
                            />
                            <br />
                            <div className="mb-6">
                                <label
                                    htmlFor="select-prosecutor"
                                    className="block text-sm font-medium text-gray-700 mb-2"
                                >
                                    {t("ResearchTopics")}
                                </label>
                                <div className="relative mb-3">
                                    <input
                                        className="bg-gray-50 py-3 w-full px-2 outline-none"
                                        placeholder={t("Name")}
                                        type="text"
                                        value={dataCollector}
                                        onChange={(e) => handleDataCollectors(e.target.value)}
                                    />
                                </div>

                                <button
                                    type="button"
                                    onClick={handleAddCollector}
                                    className="mb-4 text-[#AA232F] hover:text-blue-800 text-sm"
                                >
                                    {t("AddSelectedTopic")}
                                </button>

                                <div className="space-y-3 max-h-60 overflow-y-auto pr-2 custom-scrollbar scrollbar-hide">
                                    {dataCollectorTeam.length === 0 && (
                                        <p className="text-gray-500 text-sm italic">
                                            {t("NoTopicAddedYet")}
                                        </p>
                                    )}
                                    {dataCollectorTeam.map((member) => (
                                        <div
                                            key={member.id}
                                            className="flex items-center bg-gray-50 border border-gray-200 rounded-lg p-3 shadow-sm"
                                        >
                                            <div className="w-10 h-10 rounded-full mr-3 bg-gray-700 text-white flex items-center justify-center font-bold text-sm select-none">
                                                {getInitials(member.topic_title)}
                                            </div>

                                            <div className="flex-grow">
                                                <p className="font-semibold text-gray-800">
                                                    {member.topic_title}
                                                </p>
                                            </div>
                                            <div className="flex items-center space-x-2">
                                                <button
                                                    type="button"
                                                    onClick={() => handleRemoveCollector(member.id)}
                                                    className="text-gray-400 hover:text-red-500"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="h-5 w-5"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="#AA232F"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth={2}
                                                            d="M6 18L18 6M6 6l12 12"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="flex space-x-4 justify-between">
                                <Button
                                    type="button"
                                    variant="secondary"
                                    onClick={() => {
                                        setFormState({
                                            reason: "",
                                            letter_reference_number: "",
                                            research_topic_abstract: "",
                                            research_topic: "",
                                            letter_file: null,
                                            research_synopsis_file: null,
                                        });
                                        if (fileInputRefRequestLetter.current)
                                            fileInputRefRequestLetter.current.value = "";
                                        if (fileInputRefDraftInstruction.current)
                                            fileInputRefDraftInstruction.current.value = "";
                                        navigate(-1);
                                    }
                                    }
                                >
                                    {t("Cancel")}
                                </Button>
                                <Button
                                    variant="primary"
                                    onClick={handleSubmit}
                                >
                                    {submitting ? (
                                        <div className="flex items-center justify-center">
                                            {LoadingIcon} {t("Submitting")}
                                        </div>
                                    ) : (
                                        t("Submit")
                                    )}
                                </Button>
                            </div>
                            {validationError && (
                                <p className="text-red-600 text-sm mt-2">{validationError}</p>
                            )}
                        </div>
                    }
                    right={
                        <div className="w-full max-w-md space-y-4">
                            <Notes
                                title={t("Note")}
                                text={t("ImportantNotesText")}
                                subtext={t("ImportantNotesSubtext")}
                            />
                            <div className="bg-white rounded-xl shadow-sm p-4 space-y-4">
                                <div className="flex justify-between items-center">
                                    <div>
                                        <h2 className="font-semibold">{t("DocumentRequirements")}</h2>
                                        <p className="text-sm text-gray-500">
                                            {t("DocumentRequirementsDescription")}
                                        </p>
                                    </div>
                                </div>
                                <div className="border-t pt-2 space-y-2">
                                    <div className="flex justify-between items-center p-2 hover:bg-gray-100 rounded-md cursor-pointer">
                                        <span className="text-sm font-medium">
                                            {t("ConductingLegalResearch")}
                                        </span>
                                    </div>
                                    <div className="flex justify-between items-center p-2 hover:bg-gray-100 rounded-md cursor-pointer">
                                        <span className="text-sm font-medium">
                                            {t("LegislativeDrafting")}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                />
            </form>
            {viewTeam &&
                <TeamView teamMembers={formState.research_teams?.[teamId].prosecutors} onClose={() => setViewTeam(false)} />}
        </div>
    );
}